import { cn } from '@/lib/utils';
import type { RiskFlag as RiskFlagType } from '../../activeLoanModel';

interface RiskFlagProps {
  flag: RiskFlagType | null;
  /**
   * Days since last activity (milestone change or conversation-log entry,
   * PT calendar days). Used to label `stalled` flags ("Stalled · 14d").
   */
  daysStale?: number | null;
  className?: string;
}

const FLAG_STYLE: Record<RiskFlagType, { bg: string; text: string }> = {
  // warning-strong, not warning: the text sits on the amber tint, which lowers contrast.
  stalled: { bg: 'bg-[hsl(38_92%_50%/0.15)]', text: 'text-warning-strong' }
};

function buildLabel(daysStale: number | null | undefined): string {
  if (daysStale === null || daysStale === undefined) {
    return 'Stalled';
  }
  return `Stalled · ${daysStale}d`;
}

export function RiskFlag({ flag, daysStale, className }: RiskFlagProps) {
  if (!flag) {
    return null;
  }
  const s = FLAG_STYLE[flag];
  const label = buildLabel(daysStale);
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[10px] font-medium whitespace-nowrap',
        s.bg,
        s.text,
        className
      )}
    >
      <span aria-hidden className="inline-block h-1 w-1 rounded-full bg-current" />
      {label}
    </span>
  );
}
